import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#F4F6F8] flex items-center justify-center p-8">
          <div className="max-w-md text-center" data-testid="error-boundary">
            <div className="w-20 h-20 bg-[#FFEBEE] rounded-full flex items-center justify-center mx-auto mb-6">
              <AlertTriangle className="w-10 h-10 text-[#C62828]" />
            </div>
            <h1 className="text-2xl font-bold text-[#0F1C2E] mb-3">
              Algo deu errado
            </h1>
            <p className="text-[#475569] mb-6">
              Ocorreu um erro inesperado. Tente recarregar a página.
            </p>
            <Button
              onClick={this.handleReset}
              data-testid="error-reset-btn"
              className="bg-[#1E3A5F] hover:bg-[#152B47] text-white"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Recarregar
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
